<template>
  <div class="card modal-card width-535 is-size-7">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="center">
          <div class="columns">
            <div class="column">
              <h1 class="title is-size-4">
                {{ $t('detailMarche.ventesMarche.popupInfoVentes.title') }}
              </h1>
            </div>
          </div>
        </div>
        <div v-for="(ech, index) in echeanciers" :key="index">
          <div class="columns">
            <div class="column is-narrow">
              <div
                :style="getStyleLegende(ech)"
                class="legende-square has-text-centered">
              </div>
            </div>
            <div class="column has-text-link">
              <b-field
                v-if="ech.facture"
                class="has-text-weight-bold mgb-0">
                <div class="mgr-5px">
                  {{ $t('detailMarche.ventesMarche.popupInfoVentes.facture') }}
                </div>
                <router-link-blank
                  :to="{ name: 'c.bodac.factures', params: { id: ech.factureId }}"
                  :message="ech.facture.code"/>
                <div class="mgl-5px">
                  {{ $t('detailMarche.ventesMarche.popupInfoVentes.factureeLe') }}
                </div>
              </b-field>
              <b-field v-else class="has-text-weight-bold mgb-0">
                {{ $t('detailMarche.ventesMarche.popupInfoVentes.echeancierPrevuPourLe') }}
              </b-field>
            </div>
            <div class="column is-2">
              {{ formatDate(ech.dateEcheancier) }}
            </div>
            <div class="column is-2 has-text-right">
              {{ formatDevise(ech.montantAPrendre) }}
            </div>
          </div>
        </div>
        <div class="center mgt-20px">
          <div class="button" @click="$parent.close">
            {{ $t('general.button.close') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import { formatDevise } from '@/services/general/filters/formatDevise';
import formatDate from '@/services/general/formatDate';
import { calculateStyleCelluleEcheancierLigne } from '@/services/planningReseauTempo/calculateStyleCelluleEtatObtenu';

export default {
  name: 'PListeEcheanciersLigne',
  components: {
    RouterLinkBlank,
  },
  props: {
    echeanciers: {
      type: Array,
      required: true,
    },
    ligneCommande: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDevise(value) {
      return formatDevise(value);
    },
    formatDate(date) {
      return formatDate(date);
    },
    getStyleLegende(echeancier) {
      return calculateStyleCelluleEcheancierLigne(echeancier, this.ligneCommande);
    },
  },
};
</script>
